<template>
  <section class="evaluation-result-no-content">
    <div class="img-container">
      <img src="@/assets/img/no-content.png" />

      <slot>
        <p class="info-text">
          暂无数据
        </p>
      </slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NoContent'
};
</script>

<style lang="scss">
.evaluation-result-no-content {
  height: 510px;
  .img-container {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 217px;
      margin-bottom: 75px;
    }
  }
}
</style>
